import React, { useState, useEffect } from 'react';
import MyinvFeesBasic from './MyinvFeesBasic';
import moment from 'moment';

const MyinvInterest = ({ myinvId }) => {
  const [fees, setFees] = useState([]);
  const [myinvestment, setMyinvestment] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (myinvId) {
      getInterestPayments();
    }
  }, [myinvId]);

  const getInterestPayments = async () => {
    try {
      const userToken = localStorage.getItem('systemToken') || '';
      const Base_url = process.env.REACT_APP_EXISTING_BASE_URL || 'https://api.caprock.com.au/';
      
      const formData = new FormData();
      formData.append('user_token', userToken);
      formData.append('myinv_id', myinvId);
      
      const response = await fetch(`${Base_url}/get-myinvestment-interest-payments`, {
        method: 'POST',
        body: formData
      });
      
      if (response.ok) {
        const data = await response.json();
        
        if (data.success === 200) {
          const feesData = data.fees;
          const investmentData = data.investment;
          
          // Process fees data
          const processedFees = feesData.map(fee => {
            const totalDueFee = fee.interest_merchant_fee + fee.interest_principle_fee;
            
            let paidFees = 0;
            if (typeof fee.interest_merchant_fee_trans_id !== 'undefined' && fee.interest_merchant_fee_trans_id > 0) {
              paidFees += fee.interest_merchant_fee;
            }
            if (typeof fee.interest_principle_fee_trans_id !== 'undefined' && fee.interest_principle_fee_trans_id > 0) {
              paidFees += fee.interest_principle_fee;
            }
            
            return {
              ...fee,
              total_due_fee: totalDueFee,
              total_paid_fee: paidFees,
              interest_date: moment(fee.interest_date).format('DD-MM-YYYY'),
              interest_amount: `${investmentData.currency_symbol} ${(typeof fee.interest_amount !== 'undefined' ? fee.interest_amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0)}`,
              interest_paid: `${investmentData.currency_symbol} ${(typeof fee.interest_paid !== 'undefined' ? fee.interest_paid.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0)}`,
              interest_balance: `${investmentData.currency_symbol} ${(typeof fee.interest_balance !== 'undefined' ? fee.interest_balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0)}`,
              interest_merchant_fee: `${investmentData.currency_symbol} ${(typeof fee.interest_merchant_fee !== 'undefined' ? fee.interest_merchant_fee.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0)}`,
              interest_principle_fee: `${investmentData.currency_symbol} ${(typeof fee.interest_principle_fee !== 'undefined' ? fee.interest_principle_fee.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0)}`,
              interest_fee_balance: `${investmentData.currency_symbol} ${(typeof fee.interest_fee_balance !== 'undefined' ? fee.interest_fee_balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0)}`,
              total_due_fee: `${investmentData.currency_symbol} ${(typeof totalDueFee !== 'undefined' ? totalDueFee.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0)}`,
              total_paid_fee: `${investmentData.currency_symbol} ${(typeof paidFees !== 'undefined' ? paidFees.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0)}`
            };
          });
          
          setFees(processedFees);
          setMyinvestment(investmentData);
        }
      }
    } catch (error) {
      console.error('Error fetching interest payments:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full px-1 py-3 border-b">
      <MyinvFeesBasic myinvId={myinvId} />
      
      <div className="principle_transactions mt-4 px-3">
        <div className="w-full overflow-x-auto">
          <table className="min-w-full table-auto border-collapse border border-gray-300">
            <thead>
              <tr className="bg-gray-50">
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Month End Dates</th>
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Interest</th>
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Interest Paid</th>
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Balance</th>
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Merchant Fees</th>
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fees On Paid Principle</th>
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total Fees Due</th>
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total Fees Paid</th>
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Balance</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="9" className="border border-gray-300 px-2 py-1 text-center">
                    <div className="flex justify-center items-center py-4">
                      <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500"></div>
                      <span className="ml-2">Loading...</span>
                    </div>
                  </td>
                </tr>
              ) : fees.length > 0 ? (
                fees.map((fee) => (
                  <tr key={fee.fee_id} className="hover:bg-gray-50">
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {fee.interest_date}
                    </td>
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {fee.interest_amount}
                    </td>
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {fee.interest_paid}
                    </td>
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {fee.interest_balance}
                    </td>
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {fee.interest_merchant_fee}
                    </td>
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {fee.interest_principle_fee}
                    </td>
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {fee.total_due_fee}
                    </td>
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {fee.total_paid_fee}
                    </td>
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {fee.interest_fee_balance}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="border border-gray-300 px-2 py-1 text-center text-gray-500">
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MyinvInterest;
